<template>
  <div class="IperMatrizPeligrosLista">
    <div class="panel panel-default mt-4">
      <div v-if="hayCambios"
        class="bg-success-changes rounded-0 d-flex justify-content-between fs-12 font-weight-bold m-0 align-items-center flex-column-changes">
        <div class="ml-2">
          <p class="mt-3">¡Nuevos cambios detectados!</p>
        </div>
        <div class="mr-2">
          <button type="button" class="btn btn-md btn-dark me-0 mb-2 mt-2" @click="obtenerRegionales()"
            :disabled="isLoading">
            <i class="fas fa-sync mr-1"></i>Refrescar Tabla
          </button>
        </div>
      </div>
      <vue-good-table class="mb-4" :columns="columns" :rows="rows" max-height="620px" :isLoading="isLoading"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          jumpFirstOrLast: true,
          perPage: 10,
          setCurrentPage: 1,
          rowsPerPageLabel: 'Matrices',
          firstLabel: 'Primera',
          lastLabel: 'Última',
          nextLabel: 'Sig.',
          prevLabel: 'Ant.',
          ofLabel: 'de',
          allLabel: 'Todos',
          dropdownAllowAll: false,
        }">
        <div slot="emptystate" class="text-center">
          <template v-if="isLoading">
            Cargando...
          </template>
          <template v-else>
            No se encontraron matrices
          </template>
        </div>
        <div></div>
        <div slot="loadingContent">
          <div class="bg-gray-800 rounded">
            <h3 class="text-4xl" style="color: #e8640c">
              <i class="fas fa-circle-notch fa-spin" style="font-size: 25pt"></i>
            </h3>
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <Matriz :propiedades="props" />
          <div v-if="props.column.field == 'estadoMatriz'" class="mt-1">
            <button class="btn"
              :class="{ botonActivo: props.row.estadoMatriz == 'Activo', botonInactivo: props.row.estadoMatriz == 'Desvinculado' }"
              @click="cambiarEstado(props.row.id, props.row.estadoMatriz)">{{ props.row.estadoMatriz }}</button>
          </div>
          <div v-if="props.column.field == 'fechaActualizacion'" class="mt-2">
            <p :class="{ ultimoAnioRojo: props.row.ultimoAnio == true }">{{ props.row.fechaActualizacion }}</p>
          </div>
          <div v-if="props.column.field == 'cantidadPeligros'" class="mt-2">
            {{ props.row.cantidadPeligros }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import _ from "lodash";
import Matriz from "./Matriz.vue";
Vue.use(VueGoodTablePlugin);
export default {
  name: "IperMatrizPeligrosLista",

  components: {
    Matriz
  },

  data() {
    return {
      hayCambios: false,
      rows: [],
      copia: [],
      columns: [
        {
          label: "OPCIONES",
          field: "opciones",
          thClass: "text-center",
          width: "150px",
        },
        {
          label: "EMPRESA",
          field: "empresa",
          width: "300px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterFn: this.filtroEmpresas,
          },
        },
        {
          label: "SECTOR",
          field: "sector",
          width: "170px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "CENTRO DE TRABAJO",
          field: "centroTrabajo",
          width: "290px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "REGIONAL",
          field: "regional",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "DIRECCIÓN",
          field: "direccion",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "DEPARTAMENTO",
          field: "departamento",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "CIUDAD",
          field: "ciudad",
          width: "200px",
          thClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "FECHA",
          field: "fechaActualizacion",
          width: "140px",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
          },
        },
        {
          label: "CANT. PELIGROS",
          field: "cantidadPeligros",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterDropdownItems: ["DE 0 A 3 PELIGROS", "DE 4 A 20 PELIGROS", "MÁS DE 20 PELIGROS"],
            filterFn: this.filtroPeligros
          },
        },
        {
          label: "ESTADO",
          field: "estadoMatriz",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: "FILTRAR",
            filterDropdownItems: ["ACTIVO", "DESVINCULADO"]
          },
        },
      ],
      isLoading: false,
      fechaActual: moment()
    };
  },

  async created() {
    await this.obtenerRegionales();
  },

  methods: {
    async obtenerRegionales() {
      this.rows = [];
      this.isLoading = true;
      this.$emit("cargando", this.isLoading);
      if (this.$store.state.global_privilegio_regionales_todas) {
        await this.obtenerMatrices(true);
      } else {
        this.$store.state.global_privilegio_regional.forEach((x) => {
          x.departamentos.forEach((y) => {
            y.municipios.forEach((z) => {
              this.obtenerMatrices(
                false,
                x.nombre_regional,
                y.nombre_departamento,
                z
              );
            });
          });
        });
      }
      this.isLoading = false;
      this.$emit("cargando", this.isLoading);
    },

    async obtenerMatrices(consulta, x, y, z) {
      /* OBTENER ÚLTIMAS ACTUALIZACIONES */
      let q = db.collection("cliente_empresa").where("em_baja", "==", true);
      if (!consulta) {
        q = q.where("em_registrado_por", "==", this.$store.state.email_session)
          .where("em_regional", "==", x)
          .where("em_departamento", "==", y)
          .where("em_ciudad", "==", z);
      }
      const querySnapshot = [];
      await q.get().then((registros) => {
        registros.forEach((doc) => {
          querySnapshot.push(doc);
        });
      })
      this.rows = await Promise.all(
        querySnapshot.map(async (doc) => {
          let empresa = doc.data().em_id_cliente_principal ? await this.obtenerEmpresa(doc.data().em_id_cliente_principal) : { id: "", nombre: "" };
          let fechaActualizacion = doc.data().em_fecha_editado;
          try {
            fechaActualizacion = fechaActualizacion.toDate();
          } catch (error) { }
          fechaActualizacion = moment(fechaActualizacion).format("YYYY-MM-DD");
          const diferenciaAnios = this.fechaActual.diff(fechaActualizacion, 'years');
          const ultimoAnio = diferenciaAnios >= 1;
          const estadoActivo = doc.data().em_activo ? 'Activo' : 'Desvinculado';
          const cantidadPeligros = await this.obtenerPeligros(doc.id);
          return {
            id: doc.id,
            empresa: empresa,
            sector: doc.data().em_sector,
            centroTrabajo: doc.data().em_trabajo,
            numeroTrabajadores: doc.data().em_num_trabajadores,
            regional: doc.data().em_regional,
            direccion: doc.data().em_direccion,
            departamento: doc.data().em_departamento,
            ciudad: doc.data().em_ciudad,
            fecha: doc.data().em_fecha,
            evaluacion_estado: doc.data().em_evaluacion,
            em_baja: doc.data().em_baja,
            estado: doc.data().em_completo,
            em_registrado_por: doc.data().em_registrado_por,
            em_visita: doc.data().em_visita,
            fechaActualizacion: fechaActualizacion,
            ultimoAnio: ultimoAnio,
            estadoMatriz: estadoActivo,
            cantidadPeligros: cantidadPeligros,
          }
        })
      );
      let set = new Set(this.rows.map(JSON.stringify));
      this.rows = Array.from(set).map(JSON.parse);
      // MOSTRAR FILAS EN LA CONSOLA
      // console.log(this.rows);
      this.copia = JSON.parse(JSON.stringify(this.rows));
      this.$emit("registros", this.copia);

      /* COPIAR CONSULTA PARA COMPARAR CAMBIOS */
      let copia = await Promise.all(
        querySnapshot.map((doc) => {
          return { ...doc.data() }
        })
      );

      /* DETECTAR ULTIMOS CAMBIOS */
      let cambios = [];
      q.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added' || change.type === 'modified') {
            cambios.push(change.doc.data());
          } else if (change.type === "removed") {
            for (let index = 0; index < this.rows.length; index++) {
              if (change.doc.id == this.rows[index].id) {
                this.rows.splice(index, 1);
              }
            }
          }
        });
        if (!_.isMatch([copia], [cambios]) && _.isMatch([cambios], [copia])) {
          this.hayCambios = true;
        } else {
          this.hayCambios = false;
        }
      });
    },

    async obtenerPeligros(id) {
      let peligros = 0;
      try {
        let response = await axios.post('https://firestore.googleapis.com/v1/projects/iper-matriz/databases/(default)/documents:runQuery', {
          structuredQuery: {
            from: [{
              collectionId: 'matriz_riesgo'
            }],
            where: {
              compositeFilter: {
                op: "AND",
                filters: [
                  {
                    fieldFilter: {
                      field: {
                        fieldPath: "em_id_cliente",
                      },
                      op: "EQUAL",
                      value: {
                        stringValue: id,
                      },
                    },
                  }
                ],
              }
            },
          }
        });
        if (response.data.length > 0) {
          peligros = response.data.filter(item => item.document).length;
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
      return peligros;
    },

    async obtenerEmpresa(id) {
      let empresa = {
        id: "",
        nombre: "",
      };
      if (id) {
        await db.collection("cliente_principal").doc(id).get().then((doc) => {
          if (doc.exists) {
            empresa = {
              id: id,
              nombre: doc.data().cl_cliente
            }
          }
        });
      }
      return empresa;
    },

    async cambiarEstado(id, estado) {
      let cambioEstado = ''
      let variableEditar = ''
      estado == 'Desvinculado' ? cambioEstado = 'Activo' : cambioEstado = 'Desvinculado'
      cambioEstado == 'Desvinculado' ? variableEditar = false : variableEditar = true
      Swal.fire({
        title: "¿Desea cambiar el estado de la Matriz de Peligro?",
        html: `Al aceptar, cambia el estado de la Matriz a <b>` + cambioEstado + `</b>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e8640c",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("cliente_empresa").doc(id).update({
            em_activo: variableEditar,
          }).then(() => {
            Swal.fire("¡Actualizado!", "Estado del centro de Trabajo actualizado correctamente", "success");
          }).catch((error) => {
            console.error("Error updating MATRIZ RIESGO ID PELIGRO: ", error);
          });
        }
      });
    },

    filtroEmpresas(data, filterString) {
      return [data].some(item => {
        return (
          item.nombre.toLowerCase().includes(filterString.toLowerCase())
        );
      });
    },

    filtroPeligros(data, filterString) {
      if (!filterString) {
        return data;
      }
      if (filterString === this.columns[7].filterOptions.filterDropdownItems[0]) {
        return data >= 0 && data <= 3;
      }
      if (filterString === this.columns[7].filterOptions.filterDropdownItems[1]) {
        return data >= 4 && data <= 20;
      }
      if (filterString === this.columns[7].filterOptions.filterDropdownItems[2]) {
        return data >= 20;
      }
    }
  },
};
</script>

<style>
.vgt-table {
  border-collapse: separate !important;
  border-spacing: 0;
  border-top: 0 !important;
  border: none !important;
}

.vgt-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.vgt-table th,
.vgt-table td {
  border-width: 0.5px !important;
}

.vgt-table thead th.sorting-desc button:before {
  border-top: 5px solid #e8640c;
}

.vgt-table thead th.sorting-asc button:after {
  border-bottom: 5px solid #e8640c;
}

.vgt-table td {
  font-size: 11pt !important;
  background: #ececec !important;
}

.vgt-table th {
  font-size: 11pt !important;
  text-align: left;
  color: white !important;
}

.vgt-table th.vgt-checkbox-col {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-table th.filter-th {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-global-search {
  background: linear-gradient(rgb(230, 231, 232), rgb(230, 231, 232));
}

.vgt-table th.vgt-checkbox-col input[type="checkbox"] {
  background-color: transparent;
  margin: 0;
  font: inherit;
  color: currentColor;
  width: 1.1em;
  height: 1.1em;
  border: 0.15em solid currentColor;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  accent-color: #e8640c;
}

.vgt-wrap__footer {
  background: rgb(230, 231, 232);
  border: none;
}

.footer__row-count__label {
  font-size: 12pt !important;
}

.vgt-table thead th {
  color: #2f2f2f !important;
  border-bottom: 1px solid #dcdfe6;
  background: linear-gradient(#f3f3f3, #f3f3f3);
}

.vgt-wrap__footer .footer__row-count__select {
  font-size: 11pt !important;
  padding: 0;
  margin-top: -6px;
  margin-left: 5px;
}

.vgt-wrap__footer .footer__navigation__page-btn span {
  font-size: 11pt;
}

.vgt-wrap__footer .footer__navigation>button:first-of-type {
  margin-right: 0px;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.right::after {
  border-left: 6px solid #e8640c;
}

.vgt-wrap__footer .footer__navigation__page-btn .chevron.left::after {
  border-right: 6px solid #e8640c;
}

.footer__navigation__page-info {
  margin: 0 2px !important;
}

.vgt-wrap__footer .footer__row-count::after {
  content: "";
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  right: 6px;
  top: 50%;
  margin-top: -1px;
  border-top: 0px solid #606266;
  border-left: 0px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: none;
  pointer-events: none;
}

input.vgt-input,
select.vgt-select,
input.vgt-input:focus {
  outline: none !important;
  border: 1px solid #e8640c !important;
}

.botonActivo {
  background-color: Green;
  color: white;
}

.botonInactivo {
  background-color: red;
  color: white;
}

.ultimoAnioRojo {
  color: red;
}

@media only screen and (max-width: 570px) {
  .vgt-wrap__footer .footer__navigation__page-btn {
    margin-left: -15px !important;
    margin-right: 15px !important;
  }

  .vgt-wrap__footer .footer__row-count__select {
    margin-right: auto;
  }

  .footer__navigation__page-info {
    width: 100%;
    margin: 10px 75px 15px 0px !important;
  }

  .vgt-pull-right {
    float: left !important;
  }

  .vgt-wrap__footer .footer__navigation__page-btn span {
    font-size: 9pt;
  }
}

.footer__navigation__page-info {
  font-size: 11pt !important;
}

.bg-success-changes {
  background-color: rgba(232, 100, 12, 0.3);
}
</style>

<style scoped>
@media only screen and (max-width: 768px) {
  .flex-column-changes {
    flex-direction: column !important;
  }
}
</style>